import { useEffect } from "react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";
import { makeStyles } from "tss-react/mui";
import { MiIcon } from "@miplatform/components";
import { HOLDS_VIEW } from "@miplatform/constants";
import * as Icons from "@mdi/js";
import { Box, Typography, useTheme } from "@mui/material";
import { useOptionsViewModel } from "./useOptionsViewModel";

const useStyles = makeStyles()((theme) => ({
  link: { textDecoration: "none" },
  option: {
    flex: 1,
    display: "flex",
    alignItems: "center",
    padding: "14px 16px",
    cursor: "pointer",
  },
  activeOption: {
    display: "flex",
    justifyContent: "flex-start",
    backgroundColor: theme.palette.primary.light,
    paddingLeft: 12,
    borderRight: `4px solid ${theme.palette.primary.main}`,
    width: "100%",
  },
  textContainer: {
    display: "flex",
    alignItems: "center",
    gap: 8,
  },
  text: {
    ...theme.typography.body2,
    color: theme.palette.text.primary,
    paddingLeft: 8,
  },
  count: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    width: 18,
    height: 18,
    padding: 2,
    borderRadius: 50,
    backgroundColor: theme.palette.red.medium,
    color: theme.palette.common.white,
    fontSize: theme.fontSize.xsmall,
    fontWeight: theme.fontWeight.bold,
  },
}));

export function Options({
  options = [],
  collapse,
  active,
  refreshSideBar = false,
  setActive,
  rootUrl,
}) {
  const { classes } = useStyles();
  const theme = useTheme();

  const { holdsCount, getHoldsCount } = useOptionsViewModel({ options });

  useEffect(() => {
    getHoldsCount();
  }, [refreshSideBar]);

  return options.map(({ icon, name, route }) => (
    <Link
      key={route}
      className={classes.link}
      to={route ? `/${rootUrl}/${route}` : null}
    >
      <Box
        className={`${classes.option} ${
          active === route && classes.activeOption
        }`}
        onClick={() => {
          setActive(route);
        }}
        data-testid="option-btn"
      >
        <MiIcon path={Icons[icon]} color={theme.palette.blue.main} />
        {!collapse && (
          <Box className={classes.textContainer}>
            <Typography className={classes.text}>{name}</Typography>
            {name === HOLDS_VIEW && holdsCount > 0 && (
              <Typography className={classes.count} data-testid="count">
                {holdsCount}
              </Typography>
            )}
          </Box>
        )}
      </Box>
    </Link>
  ));
}

Options.propTypes = {
  options: PropTypes.array,
  collapse: PropTypes.bool,
  active: PropTypes.string,
  setActive: PropTypes.func,
  refreshSideBar: PropTypes.bool,
};
